
(function(){
  /* Le theme pose sa propre police EN LIGNE sur le titre, et un style en ligne
     bat une feuille CSS, meme avec !important. On applique donc la police
     directement sur l'element, et on la repose si le theme le reconstruit. */
  function habiller(){
    var t = document.querySelector('[class*="mz-product-title"]');
    if (!t || t.dataset.almaTitre === '1') return !!t;
    t.dataset.almaTitre = '1';
    var large = window.matchMedia('(max-width:749px)').matches;
    var petit = window.matchMedia('(max-width:380px)').matches;
    t.style.setProperty('font-family', "'Jost','Archivo',Helvetica,Arial,sans-serif", 'important');
    t.style.setProperty('font-weight', '500', 'important');
    t.style.setProperty('font-size', petit ? '22px' : (large ? '24px' : '27px'), 'important');
    /* sur un telephone, la meme graisse parait plus fine : on la monte. */
    t.style.setProperty('font-weight', '500', 'important'); /* 25/09 (Lancelot : « tout semble gros ») : plus fin */
    t.style.setProperty('line-height', '1.22', 'important');
    t.style.setProperty('letter-spacing', '0', 'important');
    t.style.setProperty('color', '#0E0E0E', 'important');
    return true;
  }
  /* 10/09 : la pastille "Economisez" recevait sa couleur marron EN LIGNE
     (reglage du theme), donc la feuille CSS ne pouvait rien. On la repeint en
     noir ici, et on la descend de quelques pixels : centree a la lettre, elle
     paraissait remontee a cote des gros chiffres du prix. */
  function pastille(){
    var b = document.querySelector('[class*="economy-badge"]');
    if (!b || b.dataset.almaPast === '1') return !!b;
    b.dataset.almaPast = '1';
    b.style.setProperty('background', '#F4D54A', 'important'); /* 25/09 direction D : jaune (avant #0E0E0E) */
    b.style.setProperty('color', '#141414', 'important');
    b.style.setProperty('border-radius', '0', 'important'); /* 25/09 01h15 (Lancelot) : carré */
    /* la ligne parente aligne deja tout sur la ligne de base des chiffres :
       on laisse la pastille s'y poser au lieu de la centrer a la main. */
    b.style.setProperty('align-self', 'center', 'important');
    b.style.setProperty('position', 'relative', 'important');
    b.style.setProperty('top', '2px', 'important');
    return true;
  }
  var m = 0;
  (function bp(){ if (!pastille() && ++m < 60) setTimeout(bp, 100); })();

  /* 10/09 : on sort le bouton "Fiche technique complete" de sa section (qui est
     masquee) et on le pose dans la colonne d'achat, sous la liste de points.
     Le bouton d'origine garde son ecouteur : on ne le recree pas, on le
     DEPLACE, sinon le tiroir ne s'ouvrirait plus. */
  function ftech(){
    var b = document.querySelector('[id*="almea_com_fiche"] .almsec-flink, .almsec-flink');
    if (!b) return false;
    if (b.dataset.almaFt === '1') return true;
    var liste = document.querySelector('[class*="mz-x-features"]');
    if (!liste || !liste.parentNode) return false;
    b.dataset.almaFt = '1';
    b.className = 'alma-ftech';
    /* 10/09 : "Abmessungen" a ete renomme "Technische Daten" et ouvre
       le meme tiroir. Quand ce bouton est la, ce second lien ferait doublon :
       on le garde dans la page (c'est lui qui porte l'ecouteur d'ouverture)
       mais on ne l'affiche pas. Sur une fiche SANS variante le bouton n'existe
       pas : le lien reste alors visible, sinon la fiche technique deviendrait
       inaccessible. */
    if (document.querySelector('[class*="mz-size-guide"]')) {
      b.style.setProperty('display', 'none', 'important');
    }
    b.innerHTML = '<span>Vollständige technische Daten</span>'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    liste.parentNode.insertBefore(b, liste.nextSibling);
    return true;
  }
  /* 10/09 : Lancelot met de cote la ligne "Temperature de couleur" de la fiche
     technique le temps de fiabiliser l'info. On masque le libelle et sa valeur.
     ROLLBACK : supprimer cette fonction et son appel. */
  function sansTemp(){
    var dl = document.querySelector('.almf-spec');
    if (!dl) return false;
    if (dl.dataset.almaTemp === '1') return true;
    var k = dl.children, i;
    for (i = 0; i < k.length; i++){
      if (k[i].tagName === 'DT' && /emp[eé]rature/i.test(k[i].textContent || '')){
        k[i].style.setProperty('display', 'none', 'important');
        if (k[i + 1] && k[i + 1].tagName === 'DD') k[i + 1].style.setProperty('display', 'none', 'important');
      }
    }
    dl.dataset.almaTemp = '1';
    return true;
  }

  /* La meme mention revient dans la liste de la description produit
     ("Temperature de couleur : blanc chaud"), visible quand on deplie
     "voir plus". On la masque aussi. */
  function sansTempDesc(){
    /* la mention se presente sous plusieurs formes selon les fiches : puce de
       liste, ligne de tableau, paragraphe court. On ne masque que les lignes
       COURTES qui commencent par "Temperature", jamais un vrai paragraphe. */
    var n = document.querySelectorAll('#mz-product-description li, #mz-product-description p, #mz-product-description tr, .nty-desc__body li, .nty-desc__body p, .nty-desc__body tr, .almf-spec dt, .almsec-drw li, .almsec-drw tr');
    var i, t, vu = false;
    for (i = 0; i < n.length; i++){
      t = (n[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > 90) continue;
      if (!/^temp[eé]rature/i.test(t)) continue;
      n[i].style.setProperty('display', 'none', 'important');
      /* dans une liste de definitions, la valeur suit le libelle */
      if (n[i].tagName === 'DT'){
        var d = n[i].nextElementSibling;
        if (d && d.tagName === 'DD') d.style.setProperty('display', 'none', 'important');
      }
      vu = true;
    }
    return vu;
  }
  /* 10/09 : le bouton "Abmessungen" ne faisait rien (aucune adresse
     n'est renseignee dans le reglage du theme). Plutot que de le laisser mort,
     on le branche sur le tiroir de la fiche technique, ou les dimensions sont
     deja listees. S'il recoit une vraie adresse un jour, on n'y touche pas. */
  /* 11/09 : le lien se pose sur la DERNIERE ligne d'option, pas la premiere.
     Demande de Lancelot : quand il y a Couleur puis Longueur, il doit etre en
     face de la longueur. Avec une seule ligne d'option, rien ne bouge.
     ROLLBACK : supprimer cette fonction et son appel. */
  function guidePlace(){
    var g = document.querySelector('[class*="mz-size-guide"]');
    if (!g) return false;
    var lignes = document.querySelectorAll('[class*="mz-variant-header"]');
    if (!lignes.length) return false;
    var derniere = lignes[lignes.length - 1];
    if (g.parentNode === derniere) return true;
    derniere.appendChild(g);
    return true;
  }

  function guideDim(){
    var g = document.querySelector('[class*="mz-size-guide"]');
    if (!g) return false;
    if (g.dataset.almaGuide === '1') return true;
    var oc = g.getAttribute('onclick');
    if (oc && oc.trim()) { g.dataset.almaGuide = '1'; g.textContent = 'Technische Daten'; return true; }
    g.dataset.almaGuide = '1';
    g.textContent = 'Technische Daten';
    g.addEventListener('click', function(e){
      var f = document.querySelector('.almsec-flink, .alma-ftech');
      if (f) { e.preventDefault(); f.click(); }
    });
    return true;
  }
  /* 10/09 : sur les fiches ou la section d'origine ne sort pas, on affiche
     quand meme un lien "Technische Daten" qui ouvre le tiroir de repli. */
  /* 11/09 : mise en page du tiroir — en-tete separee, chapeau, sous-titres,
     et la liste des caracteristiques transformee en tableau deux colonnes. */
  function mise(p){
    var pan = p.querySelector('.almft__panneau');
    if (!pan || pan.dataset.almaMis === '1') return;
    var k = pan.querySelector('.almft__k'), t = pan.querySelector('.almft__t');
    var f = pan.querySelector('.almft__f'), c = pan.querySelector('.almft__c');
    if (!c) return;
    pan.dataset.almaMis = '1';
    var hd = document.createElement('div');
    hd.className = 'almft__hd';
    if (f) hd.appendChild(f);
    if (k) hd.appendChild(k);
    if (t) hd.appendChild(t);
    pan.insertBefore(hd, c);
    var prem = c.querySelector('p');
    if (prem) prem.className = 'almft__lead';
    var uls = c.querySelectorAll('ul'), u;
    for (u = 0; u < uls.length; u++) (function(ul){
      var lis = [], i, n = ul.children.length, ok = 0;
      for (i = 0; i < n; i++) lis.push(ul.children[i]);
      if (!lis.length) return;
      for (i = 0; i < lis.length; i++){
        var st = lis[i].querySelector('strong');
        if (st && lis[i].textContent.indexOf(':') > -1) ok++;
      }
      if (ok < Math.ceil(lis.length * 0.6)) return;
      var box = document.createElement('div');
      box.className = 'almft__specs';
      var ttl = document.createElement('p');
      ttl.className = 'almft__specs-k';
      ttl.textContent = 'Eigenschaften';
      ul.parentNode.insertBefore(ttl, ul);
      for (i = 0; i < lis.length; i++){
        var li = lis[i], s2 = li.querySelector('strong');
        var lab = s2 ? s2.textContent.replace(/[:\s]+$/, '') : '';
        var html = li.innerHTML;
        if (s2) html = html.replace(s2.outerHTML, '');
        html = html.replace(/^\s*:\s*/, '');
        var row = document.createElement('div');
        row.className = 'almft__row';
        row.innerHTML = '<div class="almft__lab"></div><div class="almft__val"></div>';
        row.firstChild.textContent = lab;
        row.lastChild.innerHTML = html;
        box.appendChild(row);
      }
      ul.parentNode.replaceChild(box, ul);
    }(uls[u]));
    var ps = c.querySelectorAll('p'), j;
    var tab = [];
    for (j = 0; j < ps.length; j++) tab.push(ps[j]);
    for (j = 0; j < tab.length; j++){
      var par = tab[j], st2 = par.firstElementChild;
      if (!st2 || st2.tagName !== 'STRONG') continue;
      var txt = st2.textContent.replace(/^\s+|\s+$/g, '');
      if (!txt || txt.length > 60) continue;
      var h = document.createElement('div');
      h.className = 'almft__sub';
      h.textContent = txt.replace(/\s*[:.]\s*$/, '');
      st2.parentNode.removeChild(st2);
      par.innerHTML = par.innerHTML.replace(/^\s*[:.]?\s*/, '');
      par.parentNode.insertBefore(h, par);
    }
    accordeons(c);
  }

  /* 11/09 (2) : une image en tete, puis chaque partie devient un accordeon.
     « Caracteristiques » est ouvert d'entree, le reste se deplie au clic. */
  function accordeons(c){
    if (c.dataset.almaAcc === '1') return;
    c.dataset.almaAcc = '1';
    var im = document.querySelector('[class*="product-media"] img, [class*="mz-gallery"] img, main img');
    if (im && (im.currentSrc || im.src)){
      var v = document.createElement('div');
      v.className = 'almft__vis';
      var n = new Image();
      /* 30/09 perf : copie en differe + meme jeu de tailles que la grande photo (avant : re-telechargeait la version 1000 px pendant l'affichage) */
      n.loading = 'lazy'; n.decoding = 'async';
      if (im.getAttribute('srcset')) { n.sizes = im.getAttribute('sizes') || '100vw'; n.srcset = im.getAttribute('srcset'); }
      n.src = im.getAttribute('src') || im.currentSrc || im.src;
      n.alt = '';
      v.appendChild(n);
      c.insertBefore(v, c.firstChild);
    }
    var enfants = [], i;
    for (i = 0; i < c.children.length; i++) enfants.push(c.children[i]);
    var subs = [];
    for (i = 0; i < enfants.length; i++) if (enfants[i].className === 'almft__sub') subs.push(enfants[i]);
    var specs = c.querySelector('.almft__specs');
    var specsK = c.querySelector('.almft__specs-k');
    if (!specs && !subs.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'almft__acc';
    function bloc(titre, noeuds, ouvert){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'almft__accb';
      b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      var lab = document.createElement('span');
      lab.textContent = titre;
      var sig = document.createElement('span');
      sig.className = 'sig';
      sig.textContent = ouvert ? '\u2013' : '+';
      b.appendChild(lab); b.appendChild(sig);
      var pan = document.createElement('div');
      pan.className = 'almft__accp' + (ouvert ? ' is-on' : '');
      for (var j = 0; j < noeuds.length; j++) pan.appendChild(noeuds[j]);
      b.addEventListener('click', function(){
        var o = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', o ? 'false' : 'true');
        if (o) pan.className = 'almft__accp'; else pan.className = 'almft__accp is-on';
        sig.textContent = o ? '+' : '\u2013';
      });
      wrap.appendChild(b); wrap.appendChild(pan);
    }
    if (specs){
      if (specsK && specsK.parentNode) specsK.parentNode.removeChild(specsK);
      bloc('Eigenschaften', [specs], true);
    }
    for (i = 0; i < subs.length; i++){
      var sb = subs[i], noeuds = [], n2 = sb.nextElementSibling;
      while (n2 && n2.className !== 'almft__sub' && n2.className !== 'almft__specs' && n2.className !== 'almft__specs-k'){
        var suiv = n2.nextElementSibling;
        noeuds.push(n2);
        n2 = suiv;
      }
      var t2 = sb.textContent;
      sb.parentNode.removeChild(sb);
      bloc(t2, noeuds, false);
    }
    c.appendChild(wrap);
  }
  function ftechRepli(){
    if (document.querySelector('.almsec-drw')) return true;   /* le vrai tiroir est la */
    var boite = document.getElementById('almFtechRepli');
    if (!boite) return true;                                   /* pas de description */
    if (boite.dataset.almaPret === '1') return true;
    var liste = document.querySelector('[class*="mz-x-features"]');
    if (!liste || !liste.parentNode) return false;
    boite.dataset.almaPret = '1';
    boite.hidden = false;
    mise(boite);

    function ouvrir(){ boite.classList.add('is-open'); boite.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }
    function fermer(){ boite.classList.remove('is-open'); boite.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }
    var fs = boite.querySelectorAll('[data-almft-fermer]');
    for (var i = 0; i < fs.length; i++) fs[i].addEventListener('click', fermer);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') fermer(); });

    var g = document.querySelector('[class*="mz-size-guide"]');
    if (g){
      g.textContent = 'Technische Daten';
      g.dataset.almaGuide = '1';
      g.addEventListener('click', function(e){ e.preventDefault(); ouvrir(); });
      return true;
    }
    var lien = document.createElement('button');
    lien.type = 'button';
    lien.className = 'alma-ftech';
    lien.innerHTML = '<span>Technische Daten</span>'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    lien.addEventListener('click', ouvrir);
    liste.parentNode.insertBefore(lien, liste.nextSibling);
    return true;
  }
  /* 26/10/2026 perf (Clarity : iPhone, écran gris au départ ; ~1,2 s de script mesurées sur ce fichier) :
     les 10 boucles setTimeout x60 (jusqu'à 18 s de recherches dans toute la page, chacune de son côté) sont
     remplacées par UN seul passage « tout() » : une ronde toutes les 100 ms PENDANT la lecture de la page
     (même rythme qu'avant pour ce qui arrive au fil du HTML, 6 s au plus), puis à DOMContentLoaded, à load et 1,2 s après.
     Chaque tâche s'arrête dès qu'elle a fini ; la ronde s'arrête à DOMContentLoaded.
     Le compteur d'avis (« garder ») n'est plus relu toutes les 300 ms pendant 18 s : il est relu aux mêmes
     moments + quand ses propres éléments changent (observateur limité à ces éléments, coupé après 20 s).
     Rien ne change à l'écran. RETOUR : gong-theme\sauvegardes\2026-10-26\ (version d'avant). */
  var faits = {};
  function une(nom, fn){ if (faits[nom]) return; try { if (fn()) faits[nom] = 1; } catch(e){} }
  function ftPret(){ document.documentElement.classList.add('alm-ft-pret'); }
  function tout(){
    une('pastille', pastille);
    une('repli', ftechRepli);
    une('guide', guideDim);
    une('place', function(){ if (guidePlace()) { ftPret(); return true; } return false; }); /* ensuite l'observateur ci-dessous le repose si le theme reconstruit les variantes */
    une('temp', sansTemp);
    une('tempDesc', sansTempDesc);
    une('ftech', ftech);
    une('titre', habiller);
  }
  /* le theme reconstruit parfois le bloc des variantes : on repose le lien
     sans jamais re-masquer quoi que ce soit. */
  try{
    var cible = document.querySelector('[class*="mz-buy"], [class*="mz-product"], main') || document.body;
    var obsT = 0; /* 30/09 perf : regroupé (avant : une recherche dans toute la page à chaque morceau de page lu) */
    var obs = new MutationObserver(function(){ if (obsT) return; obsT = setTimeout(function(){ obsT = 0; if (guidePlace()) ftPret(); }, 150); });
    obs.observe(cible, { childList: true, subtree: true });
    setTimeout(function(){ obs.disconnect(); }, 8000);
  }catch(e){}
  /* filet de securite : on ne laisse jamais un element invisible */
  setTimeout(ftPret, 2500);

  /* 11/09 : LE NOMBRE D'AVIS QUI DISPARAIT.
     La feuille masque la note et le nombre tant que <html> n'a pas la
     classe alm-avis-verifies, posee par la section avis. Si cette section
     tarde (connexion lente) ou ne repond pas, les chiffres restaient
     invisibles POUR TOUJOURS a cote de « Excellent ». Filet de securite :
     au bout de 2,5 s on les affiche quand meme. Mieux vaut un chiffre que
     rien. ROLLBACK : supprimer ces trois lignes. */
  setTimeout(function(){
    document.documentElement.classList.add('alm-avis-verifies');
  }, 2500);

  /* 11/09 (2) : le nombre d'avis s'affiche PUIS disparait au bout de
     quelques secondes. La section avis reecrit la note et le nombre, et
     quand elle n'a rien a mettre elle les VIDE. On retient la derniere
     valeur non vide et on la repose si elle est effacee. */
  var sel = '[class*="mz-alm-avis-nb-"],[class*="mz-alm-avis-note-"],[class*="mz-alm-avis-sep-"]';
  var memoire = {};
  function garder(){
    var l = document.querySelectorAll(sel), i;
    for (i = 0; i < l.length; i++){
      var e = l[i];
      var k = String(e.className || ('i' + i));
      var t = (e.textContent || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
      var vide = !t || t === '0' || /^0[\s\/]/.test(t) || /^0 avis/i.test(t);
      if (!vide) { memoire[k] = t; }
      else if (memoire[k]) { e.textContent = memoire[k]; }
    }
    return l.length;
  }
  var gObs = null;
  function veiller(){
    if (gObs || !window.MutationObserver) return;
    var l = document.querySelectorAll(sel), i;
    if (!l.length) return;
    gObs = new MutationObserver(function(){ garder(); });
    for (i = 0; i < l.length; i++) gObs.observe(l[i], { childList: true, characterData: true, subtree: true });
    setTimeout(function(){ try { gObs.disconnect(); } catch(e){} }, 20000);
  }

  /* une seule ronde pendant la lecture de la page */
  var dclFait = false;
  var tours = 0; /* 60 tours au plus (6 s), comme les anciennes boucles */
  (function ronde(){ tout(); if (!dclFait && document.readyState === 'loading' && ++tours < 60) setTimeout(ronde, 100); })();
  garder();
  document.addEventListener('DOMContentLoaded', function(){ dclFait = true; tout(); garder(); veiller(); });
  window.addEventListener('load', function(){ tout(); garder(); veiller(); setTimeout(function(){ tout(); garder(); }, 1200); });
  document.addEventListener('click', function(){ setTimeout(function(){ try { sansTempDesc(); sansTemp(); } catch(e){} }, 150); }, true);

  /* 30/09 perf mobile : ce script est désormais lu JUSTE APRÈS LE PRIX (le haut de la fiche s'affiche plus tôt sur téléphone).
     La fin de la section produit rappelle cette fonction pour habiller aussitôt ce qui arrive après (fiche technique, guide). */
  window.__almTitreRun = function(){ tout(); };
  window.addEventListener('resize', function(){
    var t = document.querySelector('[class*="mz-product-title"]');
    if (t) { t.dataset.almaTitre = ''; habiller(); }
  });
}());
